<template>
  <div>
    <Nuevo
      ref="Nuevo"
      :dialog="dialog"
      @dialog="dialog = $event"
      @cerrarModal="cerrarModal"
      :Item="itemSelected"
      @actualizarListado="ActualizarListadoAgregado"
      v-if="verNuevo"
      @cargarDatosAdicionales="cargarDatosAdicionales"
    />
    <MensajeTransicion
      :color="color"
      :text="mensaje"
      v-if="verMensaje"
      :top="true"
      :bottom="false"
    />

    <v-card class="rounded-lg elevation-3 overflow-hidden">
      <!-- Toolbar Header -->
      <v-toolbar
        color="secondary"
        dark
        flat
        class="table-header-toolbar px-2 px-sm-3"
      >
        <div
          class="d-flex align-center header-main-info flex-grow-1 min-width-0"
        >
          <div class="header-icon-box mr-2 mr-sm-3 flex-shrink-0">
            <v-icon color="white">mdi-truck</v-icon>
          </div>
          <div class="header-text-block min-width-0 mr-2 mr-sm-3">
            <div class="header-company-title font-weight-bold text-truncate">
              {{ Titulo || "Maestro de Vehículos" }}
            </div>
          </div>
          <v-chip
            small
            color="white"
            text-color="secondary"
            class="header-count-chip font-weight-bold elevation-1 flex-shrink-0"
          >
            <v-icon left size="16" color="secondary">mdi-counter</v-icon>
            {{ ItemTotal || total || (data ? data.length : 0) }}
          </v-chip>
        </div>

        <div class="header-help-btn ml-1 ml-sm-2 flex-shrink-0">
          <!-- Botón de Ayuda -->
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn
                class="mx-1 btn-circle-tooltip"
                icon
                dark
                target="_blank"
                :href="global.helpdesk_url + 'mant_inf_vehiculos_registrar'"
                v-on="on"
              >
                <v-icon size="25" color="amber lighten-2"
                  >mdi-help-circle-outline</v-icon
                >
              </v-btn>
            </template>
            <span>¿Necesitas ayuda?</span>
          </v-tooltip>
        </div>
      </v-toolbar>

      <div class="pa-2 pa-sm-4 pb-2">
        <!-- Barra de Control: Búsqueda y Botones -->
        <div
          class="d-flex align-center justify-space-between flex-wrap gap-2 mb-3"
        >
          <div class="search-field flex-grow-1 mr-md-3">
            <v-text-field
              v-model="search"
              @input="ActualizarListadoAgregado"
              outlined
              dense
              single-line
              hide-details
              prepend-inner-icon="mdi-magnify"
              clearable
              placeholder="Buscar por placa, código, marca, modelo..."
              class="rounded-lg"
            ></v-text-field>
          </div>

          <div
            class="action-buttons-group d-flex align-center flex-wrap gap-2 mt-2 mt-md-0"
          >
            <v-btn
              v-if="
                global._autorizacion_usuario(Permisos, $route.meta.id, ['2'])
              "
              color="primary"
              dark
              height="38"
              class="btn-nuevo-vehiculo px-4 font-weight-bold elevation-1 text-none rounded-lg"
              @click="nuevoItem()"
            >
              <v-icon left size="20">mdi-plus-circle</v-icon>
              Nuevo Vehículo
            </v-btn>

            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="success"
                  dark
                  height="38"
                  class="btn-exportar-vehiculo px-4 font-weight-bold elevation-1 text-none rounded-lg"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon left size="20">mdi-file-excel-box</v-icon>
                  Exportar
                  <v-icon right small>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list dense class="rounded-lg">
                <v-list-item @click="ExportarVehiculo('.xlsx')">
                  <v-list-item-icon class="mr-2">
                    <v-icon small color="success">mdi-file-excel</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Exportar Excel (.xlsx)</v-list-item-title>
                </v-list-item>
                <v-list-item @click="ExportarVehiculo('.csv')">
                  <v-list-item-icon class="mr-2">
                    <v-icon small color="primary">mdi-file-delimited</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Exportar CSV (.csv)</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>
      </div>

      <!-- Indicador de desplazamiento horizontal en celular -->
      <div
        class="d-flex d-sm-none align-center text-caption primary--text mb-2 px-3 pt-1"
      >
        <v-icon x-small color="primary" class="mr-1">
          mdi-gesture-swipe-horizontal
        </v-icon>
        <span>Desliza horizontalmente para ver todos los datos</span>
      </div>

      <!-- Tabla Responsiva -->
      <div class="table-responsive-wrapper">
        <v-data-table
          dense
          :headers="Cabecera"
          :items="isLoading ? [] : data"
          :items-per-page="Number(per_page)"
          loading-text="Cargando vehículos... Por favor, espere"
          :search="search"
          :loading="isLoading"
          :mobile-breakpoint="0"
          class="elevation-0 modern-table"
          no-data-text="No hay datos disponibles"
          :footer-props="{
            'items-per-page-options': [10, 25, 50, 100],
            'items-per-page-text': 'Resultados por página:',
            'page-text': `${from != null ? from : 0}-${
              to != null ? to : 0
            } de ${from == null ? 0 : total}`,
            'disable-page-before': isLoading,
            disablePagination: isLoading,
            disableItemsPerPage: isLoading,
          }"
          :page="Number(page)"
          :server-items-length="total"
          @update:options="ActualizarListado"
          :item-class="GetClass"
        >
          <template v-slot:loading>
            <v-skeleton-loader :type="'table-row@1'"></v-skeleton-loader>
          </template>

          <template v-slot:[`item.acciones`]="{ item }">
            <div class="d-flex align-center gap-1">
              <v-tooltip
                bottom
                v-if="
                  global._autorizacion_usuario(Permisos, $route.meta.id, ['3'])
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    height="24"
                    width="24"
                    color="blue lighten-2"
                    fab
                    x-small
                    dark
                    class="action-btn elevation-1"
                    @click="editarItem(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon x-small>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    height="24"
                    width="24"
                    color="#ff6b00"
                    fab
                    x-small
                    dark
                    class="action-btn elevation-1"
                    @click="instalar(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon x-small>mdi-wrench</v-icon>
                  </v-btn>
                </template>
                <span>Instalar/Desinstalar</span>
              </v-tooltip>

              <!-- Eliminar (Solo roles 1 y 2) -->
              <v-tooltip bottom v-if="puedeEliminar">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    height="24"
                    width="24"
                    color="red darken-2"
                    fab
                    x-small
                    dark
                    class="action-btn elevation-1"
                    @click="eliminarItem(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon x-small>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
            </div>
          </template>

          <template v-slot:[`item.placa`]="{ item }">
            <span class="font-weight-bold font-mono text--primary">
              {{ item.placa }}
            </span>
          </template>

          <template v-slot:[`item.marca`]="{ item }">
            {{ item.marca ? item.marca.marca : "" }}
          </template>

          <template v-slot:[`item.aplicacion`]="{ item }">
            {{ item.aplicacion ? item.aplicacion.aplicacion : "" }}
          </template>
        </v-data-table>
      </div>
    </v-card>

    <!-- Modal Confirmar Eliminación de Vehículo -->
    <v-dialog v-model="dialogDelete" persistent max-width="480px">
      <v-card class="rounded-lg elevation-3 overflow-hidden">
        <v-toolbar height="54" color="secondary" dark flat class="px-3 px-md-2">
          <v-icon left color="red lighten-3">mdi-alert-circle-outline</v-icon>
          <span class="text-subtitle-1 font-weight-medium">
            Confirmar Eliminación
          </span>
          <v-spacer></v-spacer>
          <v-btn
            icon
            dark
            @click="cerrarModalEliminar"
            class="btn-circle-tooltip"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-4 pa-md-5 text-center">
          <v-avatar color="red lighten-5" size="56" class="mb-3">
            <v-icon color="red darken-2" size="32">mdi-delete-alert</v-icon>
          </v-avatar>
          <div
            class="text-h6 font-weight-bold text--primary mb-1"
            v-if="itemAEliminar"
          >
            ¿Estas seguro de eliminar el vehiculo
            <strong
              >"{{ itemAEliminar.placa || "ID: " + itemAEliminar.id }}"</strong
            >?
          </div>
          <div class="body-2 text--secondary">
            Se eliminarán permanentemente el vehículo y toda su información
            relacionada, incluyendo inspecciones, reportes, neumáticos
            asociados.
          </div>
        </v-card-text>

        <v-card-actions
          class="pa-4 bg-light border-top d-flex justify-end align-center"
        >
          <v-btn
            outlined
            color="grey darken-1"
            class="text-capitalize px-4 rounded-lg mr-2 font-weight-medium"
            @click="cerrarModalEliminar"
            :disabled="loadingDelete"
          >
            <v-icon left small>mdi-close</v-icon>
            Cancelar
          </v-btn>

          <v-btn
            color="red darken-1"
            dark
            elevation="2"
            class="text-capitalize px-5 rounded-lg font-weight-bold"
            @click="confirmarEliminar()"
            :loading="loadingDelete"
          >
            <v-icon left small>mdi-delete</v-icon>
            Eliminar Vehículo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import router from "@/router";
import Nuevo from "./nuevo.vue";
import exportFromJSON from "export-from-json";
import MensajeTransicion from "../Alerta.vue";
import global from "@/global";
import { notif } from "@/plugins/notyf";
import { axios2 as axios } from "@/interceptor/useApi";

export default {
  props: [
    "Titulo",
    "Cabecera",
    "validacionlista",
    "Items",
    "data",
    "from",
    "to",
    "per_page",
    "page",
    "total",
    "ItemTotal",
    "Excel",
    "Crear",
    "Loading",
    "loading",
  ],
  emits: ["getVehiculos"],
  components: {
    Nuevo,
    MensajeTransicion,
  },
  watch: {
    Loading(newVal) {
      console.log("Loading:", newVal);
    },
  },
  data() {
    return {
      search: "",
      dialog: false,
      itemSelected: {
        id_planta: null,
      },
      color: "success",
      mensaje: "",
      verMensaje: false,
      verNuevo: false,
      global: global,
      pageLocal: Number(this.page) || 1,
      perPageLocal: Number(this.per_page) || 10,
      sortByLocal: "id",
      sortDescLocal: "DESC",
      dialogDelete: false,
      loadingDelete: false,
      itemAEliminar: null,
      userRole: localStorage.getItem("role") || localStorage.getItem("rol"),
    };
  },
  computed: {
    ...mapState("navigation", ["Permisos"]),
    puedeEliminar() {
      const role =
        this.userRole ||
        localStorage.getItem("role") ||
        localStorage.getItem("rol");
      return role == 1 || role == 2;
    },
    isLoading() {
      if (this.Loading !== undefined && this.Loading !== null)
        return this.Loading;
      if (this.loading !== undefined && this.loading !== null)
        return this.loading;
      return false;
    },
  },
  methods: {
    ...mapActions("vehiculo", ["cargarDatosAdicionales"]),
    nuevoItem() {
      const fecha = new Date();
      this.itemSelected = {
        id: "",
        id_configuracion: "",
        placa: "",
        prox_reencauche: "",
        id_remanente: "",
      };
      this.dialog = true;
      this.verNuevo = false;
      this.$nextTick().then(() => {
        this.verNuevo = true;
      });
    },
    editarItem(item) {
      //this.cargarConfiguracion(item.id_tipo);
      //this.cargarPosicionNeumatico(item.id_configuracion);
      item.ruta = parseInt(item.ruta);
      item.codigo = item.codigo == "-" ? null : item.codigo;
      item.id_planta = item.id_planta == "-" ? null : item.id_planta;
      item.edit_kilometraje =
        item.edit_kilometraje == undefined ? 0 : item.edit_kilometraje;
      item.editkm = item.editkm == undefined ? 0 : item.editkm;
      this.itemSelected = { ...item };
      this.dialog = true;
      this.verNuevo = false;
      this.$nextTick().then(() => {
        this.verNuevo = true;
      });
    },
    instalar(item) {
      router.push("/vehiculo/instalacion/" + item.id);
    },

    eliminarItem: function (item) {
      if (!this.puedeEliminar) {
        notif.error("No tienes permisos para realizar esta acción");
        return;
      }
      this.itemAEliminar = item;
      this.dialogDelete = true;
    },

    cerrarModalEliminar: function () {
      this.dialogDelete = false;
      this.itemAEliminar = null;
    },

    confirmarEliminar: async function () {
      if (!this.puedeEliminar) {
        notif.error("No tienes permisos para realizar esta acción");
        return;
      }
      if (!this.itemAEliminar) return;

      try {
        this.loadingDelete = true;
        const url = "vehiculos/delete";
        const payload = {
          id_vehiculo: this.itemAEliminar.id,
          id_usuario: localStorage.getItem("id"),
        };

        const response = await axios.post(url, payload);

        if (
          response.data &&
          (response.data.status === false || response.data.error)
        ) {
          notif.error(
            response.data.message ||
              response.data.error ||
              "Error al eliminar el vehículo",
          );
        } else {
          const successMsg =
            response.data?.message ||
            (typeof response.data?.success === "string"
              ? response.data.success
              : "Vehículo eliminado con éxito");
          notif.success(successMsg);
          this.cerrarModalEliminar();
          this.$emit("getVehiculos", {
            page: this.pageLocal || 1,
            per_page: this.perPageLocal || 10,
            search: this.search,
            sortBy: this.sortByLocal || "id",
            sortDirection: this.sortDescLocal || "DESC",
          });
        }
      } catch (error) {
        const errorMsg =
          error.response?.data?.message ||
          error.response?.data?.error ||
          "Error al eliminar el vehículo";
        notif.error(errorMsg);
        console.error("error!", error);
      } finally {
        this.loadingDelete = false;
      }
    },

    async ExportarVehiculo(tipo) {
      const config = { responseType: "blob" };

      // Crear notificación de carga con spinner
      const loadingNotification = notif.open({
        type: "info",
        message:
          '<div style="display:flex;align-items:center;gap:10px;"><div class="export-spinner"></div><span style="color:#333;font-size:14px;font-weight:500;">Exportando Vehiculos...</span></div>',
        duration: 0, // No se cierra automáticamente
        dismissible: false,
        className: "loading-notification",
      });

      // Agregar estilo para spinner y texto
      const style = document.createElement("style");
      style.innerHTML = `
          .export-spinner {
            border: 3px solid #e0e0e0;
            border-top: 3px solid #1976d2;
            border-radius: 50%;
            width: 22px;
            height: 22px;
            min-width: 22px;
            animation: export-spin 1s linear infinite;
          }
          @keyframes export-spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          .loading-notification .noty_body {
            display: flex;
            align-items: center;
          }
        `;
      document.head.appendChild(style);
      try {
        const response = await axios.post(
          "vehiculos/export",
          { id_cliente: localStorage.getItem("idcliente"), tipo: tipo },
          config,
        );

        // Mostrar notificación de éxito y cerrar la notificación de carga
        loadingNotification && notif.dismiss(loadingNotification);
        notif.success("Archivo exportado correctamente");

        // Procesar y descargar el archivo después de que la promesa se resuelva
        const contentType = response.headers["content-type"];
        let fileName = "Vehiculos"; // Nombre base del archivo

        // Asignar la extensión según el tipo
        switch (tipo) {
          case ".xlsx":
            fileName += ".xlsx"; // Si es tipo 'excel', usa la extensión '.xlsx'
            break;
          case ".csv":
            fileName += ".csv"; // Si es tipo 'csv', usa la extensión '.csv'
            break;
          default:
            fileName += ".xlsx"; // Default: Excel
            break;
        }

        const disposition = response.headers["content-disposition"];
        if (disposition && disposition.includes("filename=")) {
          const fileNameMatch = disposition.match(
            /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
          );
          if (fileNameMatch && fileNameMatch[1]) {
            fileName = fileNameMatch[1].replace(/['"]/g, "");
          }
        }

        if (
          contentType ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ) {
          const fileBlob = new Blob([response.data], { type: contentType });
          const downloadLink = document.createElement("a");
          downloadLink.href = URL.createObjectURL(fileBlob);
          downloadLink.download = fileName;
          downloadLink.click();
        } else {
          throw new Error("La respuesta no es un archivo Excel");
        }
      } catch (error) {
        // Cerrar la notificación de carga si hubo un error
        loadingNotification && notif.dismiss(loadingNotification);

        // Mostrar notificación de error
        notif.error("Error al exportar vehículos");
        console.error("Error al descargar el archivo:", error);
      }
    },

    DescargarExcel(param) {
      const data = this.Items;
      const nombreArchivo = "download";
      if (param == 1) {
        const exportType = exportFromJSON.types.xls; //xls, json, css, html,txt
        exportFromJSON({
          data,
          nombreArchivo,
          exportType,
        });
      } else {
        const exportType = exportFromJSON.types.csv; //xls, json, css, html,txt
        exportFromJSON({
          data,
          nombreArchivo,
          exportType,
        });
      }
    },
    ActualizarListado({ page, itemsPerPage, sortBy, sortDesc }) {
      this.pageLocal = page ? page : 1;
      this.perPageLocal = itemsPerPage ? itemsPerPage : 10;
      this.sortByLocal = sortBy.length != 0 ? sortBy[0] : "id";
      this.sortDescLocal =
        sortDesc.length == 0 ? "DESC" : sortDesc[0] ? "ASC" : "DESC";
      this.$emit("getVehiculos", {
        page: page ? page : 1,
        per_page: itemsPerPage ? itemsPerPage : 10,
        search: this.search,
        sortBy: sortBy.length != 0 ? sortBy[0] : "id",
        sortDirection:
          sortDesc.length == 0 ? "DESC" : sortDesc[0] ? "ASC" : "DESC",
      });
    },
    cerrarModal(valor) {
      this.verNuevo = false;
    },
    ActualizarListadoAgregado() {
      this.$emit("getVehiculos", {
        page: 1,
        per_page: this.perPageLocal ? this.perPageLocal : 10,
        search: this.search,
        sortBy: this.sortByLocal ? this.sortByLocal : "id",
        sortDirection: this.sortDescLocal ? this.sortDescLocal : "DESC",
      });
    },
    GetClass(item) {
      return item.flag_id && item.flag_id != null ? "bg-gray-light" : "";
    },
  },
};
</script>
<style scoped>
/* Toolbar y Header Responsive */
.table-header-toolbar {
  min-height: 56px;
}

.table-header-toolbar ::v-deep .v-toolbar__content {
  padding: 8px 14px !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-main-info {
  display: flex;
  align-items: center;
  min-width: 0;
  overflow: hidden;
}

.header-icon-box {
  width: 38px;
  height: 38px;
  min-width: 38px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-text-block {
  min-width: 0;
  overflow: hidden;
}

.header-company-title {
  font-size: 1.1rem;
  line-height: 1.25;
  letter-spacing: 0.3px;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-count-chip {
  font-size: 0.85rem !important;
  height: 28px !important;
}

.modern-table {
  border-top: 1px solid #e2e8f0;
}

.modern-table ::v-deep table {
  min-width: 1150px;
  width: 100%;
}

.modern-table ::v-deep thead tr:not(.v-data-table__progress) th {
  background-color: #424242 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  font-size: 0.8rem !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  white-space: nowrap;
  border-bottom: 2px solid #212121 !important;
  border-right: 1px solid rgba(255, 255, 255, 0.12) !important;
  padding: 10px 14px !important;
  height: 42px !important;
}

/* Sticky primera columna (Opc. / Acciones) */
.modern-table ::v-deep thead th:first-child {
  position: sticky !important;
  left: 0 !important;
  z-index: 4 !important;
  background-color: #424242 !important;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.15) !important;
}

.modern-table ::v-deep tbody tr td:first-child {
  position: sticky !important;
  left: 0 !important;
  z-index: 2 !important;
  background-color: #ffffff !important;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.06) !important;
}

.modern-table ::v-deep tbody tr:hover td:first-child {
  background-color: #f8fafc !important;
}

.modern-table ::v-deep tbody tr.bg-gray-light td:first-child {
  background-color: #ffe7a9 !important;
}

.modern-table
  ::v-deep
  thead
  tr:not(.v-data-table__progress)
  th
  .v-data-table-header__icon {
  color: #ffffff !important;
}

.modern-table ::v-deep .v-data-table__progress th {
  background: transparent !important;
  background-color: transparent !important;
  border: none !important;
  padding: 0 !important;
  height: auto !important;
}

.modern-table ::v-deep .v-data-table__empty-wrapper td {
  background: transparent !important;
  background-color: transparent !important;
}

.modern-table ::v-deep td {
  font-size: 0.85rem !important;
  padding: 8px 14px !important;
  border-bottom: 1px solid #f1f5f9 !important;
  vertical-align: middle;
}

.modern-table ::v-deep tbody tr:hover {
  background-color: #f8fafc !important;
  transition: background-color 0.15s ease-in-out;
}

.modern-table ::v-deep .v-data-footer {
  border-top: 1px solid #e2e8f0;
  background-color: #f8fafc;
  font-size: 0.82rem;
  padding: 8px 16px;
}

.table-responsive-wrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-responsive-wrapper::-webkit-scrollbar {
  height: 6px;
}

.table-responsive-wrapper::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.search-field {
  max-width: 360px;
  min-width: 220px;
}

.action-btn {
  transition: transform 0.18s ease-in-out, box-shadow 0.18s ease-in-out;
}

.action-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2) !important;
}

.font-mono {
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier,
    monospace;
}

.gap-1 {
  gap: 4px;
}

.gap-2 {
  gap: 8px;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip ::v-deep .v-btn__content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  line-height: 1 !important;
}

.btn-circle-tooltip ::v-deep .v-icon {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
}

.bg-gray-light {
  background-color: #ffe7a9 !important;
}

.bg-light {
  background-color: #f8fafc !important;
}

.border-top {
  border-top: 1px solid #e2e8f0 !important;
}

.loading-notification {
  display: flex;
  align-items: center;
  justify-content: center;
  color: gray;
}

.loading-notification .notyf__wrapper .notyf__message {
  display: flex;
}

/* ============================================================
   RESPONSIVE: Mobile (max 600px)
   ============================================================ */
@media (max-width: 600px) {
  .table-header-toolbar {
    min-height: 48px;
  }

  .table-header-toolbar ::v-deep .v-toolbar__content {
    padding: 6px 10px !important;
  }

  .header-icon-box {
    width: 32px;
    height: 32px;
    min-width: 32px;
    border-radius: 6px;
  }

  .header-icon-box .v-icon {
    font-size: 18px !important;
  }

  .header-company-title {
    font-size: 0.88rem !important;
    line-height: 1.2;
  }

  .header-count-chip {
    font-size: 0.75rem !important;
    height: 24px !important;
    padding: 0 6px !important;
  }

  .header-count-chip .v-icon {
    font-size: 14px !important;
    margin-right: 2px !important;
  }

  .search-field {
    width: 100% !important;
    max-width: 100% !important;
    margin-right: 0 !important;
  }

  .action-buttons-group {
    width: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    gap: 8px !important;
  }

  .btn-nuevo-vehiculo,
  .btn-exportar-vehiculo {
    width: 100% !important;
    max-width: 100% !important;
    justify-content: center !important;
  }

  .action-buttons-group .v-menu {
    width: 100% !important;
    display: block !important;
  }

  .modern-table ::v-deep thead th {
    font-size: 0.72rem !important;
    padding: 8px 10px !important;
    height: 38px !important;
  }

  .modern-table ::v-deep td {
    font-size: 0.78rem !important;
    padding: 6px 10px !important;
  }

  .modern-table ::v-deep .v-data-footer {
    flex-wrap: wrap;
    justify-content: center;
    padding: 8px 6px;
    gap: 6px;
  }

  .modern-table ::v-deep .v-data-footer__select {
    margin-right: 6px;
  }

  .modern-table ::v-deep .v-data-footer__pagination {
    margin: 0 4px;
  }
}

@media (max-width: 768px) and (min-width: 601px) {
  .search-field {
    max-width: 100%;
    width: 100%;
  }
}
</style>
